"use client";

import { useAuthBlobUrl } from "@/lib/auth-blob";

/**
 * Видео из приватной отдачи бэка (/kb/files/*): fetch с Bearer-токеном → blob URL
 * (общая реализация в lib/auth-blob). http(s)/data/blob — как есть.
 * Грузит файл целиком в blob (для коротких клипов ок).
 */
export function AuthVideo({ src, className, style, controls = true, muted, onClick }: {
  src?: string | null;
  className?: string;
  style?: React.CSSProperties;
  controls?: boolean;
  muted?: boolean;
  onClick?: () => void;
}) {
  const { url } = useAuthBlobUrl(src, { mode: "any" });
  if (!url) return null;
  return <video src={url} controls={controls} muted={muted} onClick={onClick} className={className} style={style} />;
}
